/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "../Lang"
import BaseCom from "../BaseCom";
import FormInput from "../FormInput";
import Icon from "../Icon";

export default class Meds extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: {},
            list: []
        };
    }

    async componentDidMount() {
        await this.load();
        this.sync();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.list !== this.props.list) {
            this.sync();
        }
    }

    load = async () => {
        await this.fillListAsync('/api/med/list', 'meds');
    }

    sync = () => {
        this.setState({ list: this.props.list || [] });
    }

    add = () => {
        let list = [...this.state.list];
        list.push({});
        this.setState({ list: list });
    }

    remove = (item) => {
        let list = [...this.state.list];
        list = list.filter(i => i !== item);
        this.setState({ list: list });
        this.change(null, list);
    }

    selectMed = (line, v) => {
        let med = this.state.meds.find(m => m.id === parseInt(v));
        if (!med) return;
        line.medID = med.id;
        this.change();
    }

    change = (e, list) => {
        if (!list) list = this.state.list;
        this.setState({ list: [...list] });
        var dups = false;
        var checkList = [...list];
        checkList.forEach(i => {
            if (checkList.find(x => x.medID === i.medID) !== i) {
                dups = true;
            }
        })
        if (dups) {
            this.warning('Duplicate medications are not allowed. Medications will not save until corrected.');
            return;
        }
        this.props.onChange?.(list);
    }

    render() {
        return (
            <div>
                {!this.props.noLabel && <label className="form-label"><L>Medications</L></label>}
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th><L>Medication</L></th>
                            <th><L>Dosage</L></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list.map((item, i) => (
                            <tr key={i}>
                                <td>{item.medication}
                                    <FormInput
                                        model={item}
                                        label="Medication"
                                        name="medID"
                                        type="select"
                                        options={this.state.meds || []}
                                        onChange={(v) => this.selectMed(item, v)}
                                        labelAsPlaceholder
                                        required
                                        disabled={this.props.disabled}
                                    />
                                </td>
                                <td>
                                    <FormInput
                                        model={item}
                                        label="Dosage"
                                        name="dosage"
                                        type="text"
                                        onChange={() => this.change()}
                                        labelAsPlaceholder
                                        disabled={this.props.disabled}
                                    />
                                </td>
                                <td>
                                    {!this.props.disabled && <button className="btn btn-danger" onClick={() => this.remove(item)}><Icon icon="faTrash" /></button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {!this.props.disabled && <div>
                    <button className="btn btn-primary" onClick={() => this.add()}><Icon icon="faPlus" /> <L>Add</L></button>
                </div>}
            </div>
        );
    }
}